import { LOGIN_PATH } from '../../api/paths';
export const api = async (path, init) => {
  const response = await fetch(path, init);
  const {
    origin,
    href
  } = window.location;
  if (response.status === 401) {
    const loginUrl = new URL(LOGIN_PATH, origin);
    loginUrl.searchParams.set('redirect_url', href);
    window.location.href = loginUrl.toString();
  }
  if (response.status >= 400 && response.status !== 401) {
    const error = new Error(`Request failed with status ${response.status}`);
    error.status = response.status;
    error.url = response.url;
    throw error;
  }
  return response;
};